import { EMPLOYEE_CHANGE_TYPES, INCIDENCE_TYPES, LEAVE_CHANGE_TYPES } from './Types'

export const isLeaveType = (type: string) => {
  return Object.values(LEAVE_CHANGE_TYPES).includes(type)
}

export const isTerminationType = (type: string) => {
  return INCIDENCE_TYPES.termination === type
}

export const isCostCenterType = (type: string) => {
  return INCIDENCE_TYPES.cost_center === type
}

export const isContractType = (type: string) => {
  return INCIDENCE_TYPES.contract === type
}

export const isHiringType = (type: string) => {
  return INCIDENCE_TYPES.hiring === type
}

export const isManualType = (type: string) => {
  return INCIDENCE_TYPES.manual_incidence === type
}

export const isLegalEntityType = (type: string) => {
  return INCIDENCE_TYPES.legal_entity === type
}

export const isEmployeeDataType = (type: string) => {
  return Object.values(EMPLOYEE_CHANGE_TYPES).includes(type)
}
